import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { normalizeOperadoras } from '@gestor-web/@core/utils';
import {
  RedefinirSenhaModel,
} from '@gestor-web/app/pages/private/usuarios/components/redefinir-senha-dialog/redefinir-senha-dialog.model';
import { environment } from '@gestor-web/environments/environment';
import { map } from 'rxjs/operators';
import { Api } from '../api';
import {
  ApiResponse,
  Operadora,
  OperadoraModulo,
  PAGE_PARAMS_ALL,
  PageParams,
  Usuario,
  UsuarioConvite,
  UsuarioOperadora,
  VinculoUsuarioOperadoraAdmin,
  VinculoUsuarioOperadoraParams,
} from '../ords/model';
import { PapelAcessoItem } from '../ords/model/papel-acesso';

const MODULE_PATH = '/admin';

@Injectable({ providedIn: 'root' })
export class AdminGoApi extends Api {
  constructor(http: HttpClient) {
    super(`${environment.API_GO_BASE_PATH}${MODULE_PATH}`, http);
  }

  updatePapeisComite(regans: string, cd_usuario: string, lt_comite_papel: string) {
    return this.post<void>(`/usuarios/${cd_usuario}/operadoras/${regans}/papeis-comite`, { lt_comite_papel });
  }

  fetchUsuarios(regans?: string, page: PageParams = PAGE_PARAMS_ALL) {
    const params = { ...page };
    if (regans) {
      params['regans'] = regans;
    }
    return this.get<ApiResponse<UsuarioOperadora>>('/usuarios', params);
  }

  fetchPapeisAcesso() {
    return this.get<ApiResponse<PapelAcessoItem>>('/papeis-acesso');
  }

  fetchOperadorasClientes() {
    return this.get<ApiResponse<Operadora>>('/operadoras').pipe(
      map(response => {
        response.items = normalizeOperadoras(response.items);
        return response;
      }),
    );
  }

  fetchModulosDasOperadoras(regans: string) {
    return this.get<ApiResponse<OperadoraModulo>>(`/operadoras/${regans}/modulos`);
  }

  /**
   * Busca todas as operadoras relacionadas com um usuario.
   */
  fetchOperadorasVinculadasAoUsuario(cd_usuario: string) {
    return this.get<ApiResponse<VinculoUsuarioOperadoraAdmin>>(`/usuarios/${cd_usuario}/operadoras`).pipe(
      map(response => {
        response.items = normalizeOperadoras(response.items);
        return response;
      }),
    );
  }

  /**
   * Atualiza os dados de um usuário existente.
   */
  editarUsuarios(usuario: Usuario) {
    return this.put<any>(`/usuarios/${usuario.cd_usuario}`, usuario);
  }

  /**
   * Exclui o usuário da base do gestor idss e do KeyCloak
   */
  excluirUsuario(cd_usuario: string) {
    return this.delete(`/usuarios/${cd_usuario}`);
  }

  /**
   * Vincula um usuário a uma operadora informada.
   */
  vincularOperadoraUsuario(cd_usuario: string, cd_registro_ans: string, vinculo: VinculoUsuarioOperadoraParams) {
    return this.post<ApiResponse<Operadora>>(`/usuarios/${cd_usuario}/operadoras/${cd_registro_ans}`, vinculo);
  }

  desvincularOperadoraUsuario(cd_usuario: string, cd_registro_ans: string) {
    return this.delete(`/usuarios/${cd_usuario}/operadoras/${cd_registro_ans}`);
  }

  editarVincularOperadoraUsuario(cd_usuario: string, cd_registro_ans: string, vinculo: VinculoUsuarioOperadoraParams) {
    return this.put<ApiResponse<Operadora>>(`/usuarios/${cd_usuario}/operadoras/${cd_registro_ans}`, vinculo);
  }

  /**
   * Convidar um usuário para o gestor IDSS.
   *
   * Este serviço insere um usuário na base de dados do gestor,
   * cria um usuário no keycloak e envia uma mensagem de verificação de email.
   **/
  convidarUsuario(convite: UsuarioConvite) {
    return this.post('/usuarios/convite', convite);
  }

  /**
   * Reenvia convite para o usuário informado.
   */
  reenviarConvite(cd_usuario: string) {
    return this.post(`/usuarios/${cd_usuario}/convite-reenvio`);
  }

  /**
   * Redefine senha do usuário informado.
   */
  redefinirSenha(cd_usuario: string, body: RedefinirSenhaModel) {
    return this.post(`/usuarios/${cd_usuario}/atualiza-senha`, body);
  }
}
